import type { SVGProps } from "react";

export const Buffer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    style={{}}
    version="1.1"
    viewBox="0 0 86.7 97.9"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    y="0px"
    {...props}
  >
    <title>Buffer</title>

    <g>
      <path
        d="M0,22.3L43.1,0l43.6,22.3L43.1,44.8L0,22.3z M43.1,83.1l-29.4-16L0,74.5l43.1,23.4l43.6-23.4l-13.9-7.4   L43.1,83.1z M13.7,42l29.4,14.5L72.9,42l13.9,6.8L43.1,69.9L0,48.7L13.7,42z"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "currentColor",
        }}
      />
    </g>
  </svg>
);

export default Buffer;
